<template>
  <div class="view contact">
    <h1>Kontakt</h1>
    <h5>Nehmen Sie mit uns Kontakt auf, wir freuen uns auf den Austausch</h5>
    <div class="contact-form" :loading="loading">
      <form @submit.prevent="sendContact">
        <div class="fieldgroup">
          <div class="field m">
            <div class="fieldgroup">
              <div class="field">
                <select v-model="contactModel.type" required>
                  <option value="">Ich bin…</option>
                  <option value="client">ein/e Kandidat/in</option>
                  <option value="company">ein/e Ansprechpartner/in im Unternehmen</option>
                </select>
              </div>
            </div>
            <div class="fieldgroup">
              <div class="field">
                <input type="text" placeholder="Vorname" v-model="contactModel.firstname" required>
              </div>
            </div>
            <div class="fieldgroup">
              <div class="field">
                <input type="text" placeholder="Nachname" v-model="contactModel.lastname" required>
              </div>
            </div>
            <div class="fieldgroup">
              <div class="field">
                <input type="email" placeholder="E-Mail" v-model="contactModel.email" required>
              </div>
            </div>
            <div class="fieldgroup">
              <div class="field">
                <input type="tel" placeholder="Telefon" v-model="contactModel.phone" required>
              </div>
              <!-- <div class="field m">
                <label>Mobile</label>
                <input type="text" v-model="contactModel.mobile" required>
              </div> -->
            </div>
          </div>
          <div class="field m">
            <div class="fieldgroup m">
              <div class="field m">
                <input type="text" placeholder="Unternehmensname" v-model="contactModel.company" :disabled="contactModel.type !== 'company'" :required="contactModel.type === 'company'">
              </div>
              <div class="field m">
                <input type="text" placeholder="Role" v-model="contactModel.role" :disabled="contactModel.type !== 'company'" :required="contactModel.type === 'company'">
              </div>
            </div>
            <div class="fieldgroup">
              <div class="field">
                <input type="text" placeholder="Betreff" v-model="contactModel.subject" required>
              </div>
            </div>
            <div class="fieldgroup">
              <div class="field">
                <textarea placeholder="Ihre Nachricht an uns" v-model="contactModel.message" required></textarea>
              </div>
            </div>
            <div class="fieldgroup" v-if="error">
              <div class="field">
                <div class="error">{{error}}</div>
              </div>
            </div>
            <div class="fieldgroup">
              <div class="field">
                <div class="buttons">
                  <div class="checks">
                    <div class="check">
                      <CheckBox v-model="contactModel.newsletter" />
                      <span>Melden Sie sich für unseren Newsletter an.<span class="tooltip"><div class="tooltip-holder"><div class="tooltip-text"><i class="fas fa-info-circle"></i>Unser Newsletter enthält aktuelle News rund um das Thema Human Resources, unser Unternehmen THRONE-Recruiting, offene HR-Vakanzen sowie Beiträge aus unserem Newsroom.</div></div></span></span>
                    </div>
                    <div class="check">
                      <CheckBox v-model="contactModel.tos" required />
                      <span>Ich habe die <router-link to="/pages/terms-and-conditions">Allgemeinen Geschäftsbedingungen</router-link>, und <router-link to="/pages/privacy-policy">Datenschutzbestimmungen</router-link> gelesen und bin damit einverstanden.</span>
                    </div>
                  </div>
                  <button class="btn" :sent="sent" type="submit">Senden</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CheckBox from '../components/CheckBox'

export default {
  name: 'contact',
  components: {
    CheckBox
  },
  data() {
    return {
      loading: false,
      contactModel: {
        type: '',
        firstname: '',
        lastname: '',
        company: '',
        role: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        tos: false,
        newsletter: false
      },
      sent: false,
      error: null
    }
  },
  computed: {
    ...mapGetters({
      functions: 'getFunctions'
    })
  },
  methods: {
    sendContact() {
      if(this.loading || !this.contactModel.tos) return
      this.error = null
      this.loading = true
      this.functions.httpsCallable('createContact')(this.contactModel)
      .then(() => {
        this.loading = false
        this.sent = true
        this.contactModel = {
          type: '',
          firstname: '',
          lastname: '',
          company: '',
          role: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        }
        setTimeout(() => this.sent = false, 3500)
      })
      .catch(err => {
        console.log(err)
        this.error = err.message
        this.loading = false
      })
    }
  },
  mounted: function() {
    this.$store.commit('setTransition', false)
  }
}
</script>

<style scoped>
.contact {
  padding: 21.76vh 17.29vw 0;
}

.contact h1 {
  font: 400 3.98vh/1 'Exodus Demo St';
  color: #ffd675;
  text-align: center;
  margin: 0 0 1.48vh;
}

.contact h5 {
  text-align: center;
  font-size: 1.3vh;
  letter-spacing: .4em;
  font-weight: 500;
  margin: 0;
}

.contact form {
  margin-top: 2.22vh;
}

.contact .fieldgroup:not(:last-child) {
  margin-bottom: 2.3vh;
}

.contact .fieldgroup .field {
  padding: 0 1.04vw;
}

.contact .fieldgroup .field .fieldgroup.m {
  padding: 0 .4vw;
}

.contact .fieldgroup .field .field.m {
  padding: 0 .64vw;
}

.contact form > .fieldgroup > .field {
  padding: 0;
}

.contact form .error {
  margin: -10px 0;
}

.contact input,
.contact textarea,
.contact select {
  background-color: transparent;
  border-radius: 0;
  border: 1px solid rgba(255, 255, 255, .5);
  height: 6.39vh;
  padding: 0 1.66vw;
}

.contact input[disabled] {
  border-color: rgba(82, 82, 102, 0.5);
  color: rgba(82, 82, 102, 0.5);
}

.contact select {
  background-position: 93% center;
  background-size: 2.5vh auto;
}

.contact textarea {
  padding-top: 2.4vh;
  height: 23.7vh;
  resize: none;
}

.contact input::placeholder,
.contact textarea::placeholder,
.contact select::placeholder {
  color: #fff;
  opacity: 1;
}

.contact input[disabled]::placeholder {
  color: rgba(82, 82, 102, 0.5);
}

.contact .buttons {
  display: flex;
  justify-content: space-between;
}

.contact .buttons .check {
  display: flex;
  margin-bottom: 1.48vh;
}

.contact .buttons .check .checkbox {
  flex-shrink: 0;
}

.contact .buttons .check span {
  margin-left: .83vw;
  font-size: .78vw;
}

.contact .buttons .check a {
  text-decoration: underline;
}

.contact .buttons .btn {
  width: 9.58vw;
  height: 6.39vh;
  font-size: 1.57vh;
  text-transform: uppercase;
  letter-spacing: .3em;
  font-weight: 900;
  background: #ffd675;
  color: #0A1612;
  flex-shrink: 0;
  margin-left: 1.5vw;
  transition: background .16s ease-out, color .16s ease-out, border-color .16s ease-out;
}

.contact .buttons .btn[sent] {
  background: none;
  border-color: transparent;
  color: #ffd675;
  font-size: 0;
}

.contact .buttons .btn:after {
  content: '';
  opacity: 0;
  font-size: 1.57vh;
  transition: opacity .16s ease-out;
}

.contact .buttons .btn[sent]:after {
  content: 'Gesendet!';
  opacity: 1;
}

.tooltip {
  position: relative;
  width: 14px;
  height: 14px;
  display: inline-block;
  z-index: 3;
}

.tooltip i {
  position: relative;
  z-index: 4;
  color:#ffd675;
}

.tooltip .tooltip-holder {
  position: absolute;
  bottom: -3px;
  right: 0;
  width: 20vw;
  overflow: hidden;
  padding: 44px 0 0 16px;
  pointer-events: none;
}

.tooltip .tooltip-text {
  position: relative;
  padding: 2vh 1.5vw;
  color: transparent;
  transform: translate(calc(95% + 14px), calc(91% + 14px));
  transition: .16s transform .16s ease-out, background .16s ease-out, color .16s ease-out;
  line-height: 1.875;
}

.tooltip:hover .tooltip-holder {
  pointer-events: all;
}

.tooltip .tooltip-holder:hover .tooltip-text {
  transition: transform .16s ease-out, .16s background .16s ease-out, .16s color .16s ease-out;
  transform: translate(0%, -28px);
  color: #fff;
  background: rgba(82, 82, 102, 1);
}

.tooltip .tooltip-text i {
  position: absolute;
  top: -14px;
  left: -14px;
  transition: transform .16s ease-out;
  transform-origin: top left;
}

.tooltip .tooltip-holder:hover .tooltip-text i {
  transition-delay: .16s;
  transform: scale(2);
}

@media screen and (max-width: 1024px) {
  .contact {
    padding: 0 42px;
  }
  .contact h1 {
    font-size: 34px;
    margin-bottom: 12px;
  }
  .contact h5 {
    font-size: 11px;
  }
  .contact form {
    margin-top: 40px;
  }
  .contact form .fieldgroup,
  .contact form .fieldgroup.m,
  .contact .fieldgroup .field,
  .contact .fieldgroup .field .field.m,
  .contact .fieldgroup:not(:last-child),
  .contact .fieldgroup .field .fieldgroup.m {
    flex-flow: column nowrap;
    padding: 0;
    margin: 0;
  }
  .contact .fieldgroup .field {
    margin: 0 0 20px !important;
  }
  .contact form > .fieldgroup > .field {
    margin: 0 !important;
  }
  .contact form .fieldgroup > .field {
    width: 100%;
  }
  .contact input,
  .contact textarea,
  .contact select {
    height: 42px;
    padding: 0 16px;
    font-size: 11px;
    border-color: rgba(82, 82, 102, 0.77);
  }
  .contact textarea {
    padding: 8px 16px;
    height: 188px;
  }
  .contact .buttons {
    flex-flow: column nowrap;
    margin-bottom: -20px;
  }
  .contact .buttons .check {
    margin-bottom: 16px;
  }
  .contact .buttons .check span {
    font-size: 13px;
    margin-left: 16px;
  }
  .contact .buttons .btn {
    width: 100%;
    margin: 20px 0 0;
    height: 72px;
    font-size: 12px;
  }
  .tooltip .tooltip-holder {
    width: 70vw;
  }
  .tooltip .tooltip-text {
    padding: 16px 24px;
  }
}
</style>

